import React from 'react';
import styled from 'styled-components';
import ModalCore from './ModalCore.js';
import { connect } from "react-redux";
import { setValues, actCloseModal } from './redux';
import { Imglist } from '../../constants/ImagesList';

const RewardsModal = (props) => {
    return (
        <ModalCore name="rewards" outSideClick={true}>
            <RewardModalContent className="rewardmessage">
                <div className="rewardmessage__close" onClick={()=>props.setValues({modal_open: ''})}>
                    <img src={Imglist.btn_close} alt=''/>
                </div>
                <div className="rewardmessage__head">
                    ของรางวัลทั้งหมด
				</div>
                <div className="rewardmessage__rulecontent">
                    <div className="rewardmessage__text-title-small">
                        <img src={Imglist.crown} className="rewardmessage__icon rewardmessage__icon--3" alt=''/>
                        <div>
                            ผู้ที่ทำคะแนนได้สูงสุด (King of Ranking)
                        </div>
                    </div>
                    <div className="rewardmessage__image-1">
                        <img src={Imglist.reward_row_1} alt=''/>
                    </div>
                    <div className="rewardmessage__text-title-small">
                        <img src={Imglist.cup} className="rewardmessage__icon" alt=''/>
                        <div>
                            ผู้เล่นชนะมากที่สุดในทีม (อันดับ1-3) ของทีมที่ได้อันดับ 1 และ 2
                        </div>
                    </div>
                    <div className="rewardmessage__image-1">
                        <img src={Imglist.reward_row_2_1} alt=''/>
                        <img src={Imglist.reward_row_2_2} alt=''/>
                    </div>
                    <div className="rewardmessage__text-title-small">
                        <img src={Imglist.cup} className="rewardmessage__icon" alt=''/>
                        <div>
                            ผู้เล่นชนะมากที่สุดในทีม (อันดับ1-3) ของทีมที่ได้อันดับ 3 และ 4
                        </div>
                    </div>
                    <div className="rewardmessage__image-1">
                        <img src={Imglist.reward_row_3_1} alt=''/>
                        <img src={Imglist.reward_row_3_2} alt=''/>
                    </div>
                    <div className="rewardmessage__text-title-small">
                        <img src={Imglist.medal_1} className="rewardmessage__icon rewardmessage__icon--1" alt=''/>
                        <div>
                            ทีมที่ได้อันดับ 1
                        </div>
                    </div>
                    <div className="rewardmessage__image-1">
                        <img src={Imglist.reward_row_4_1} alt=''/>
                        <img src={Imglist.reward_row_4_2} alt=''/>
                    </div>
                    <div className="rewardmessage__text-title-small">
                        <img src={Imglist.medal_2} className="rewardmessage__icon rewardmessage__icon--1" alt=''/>
                        <div>
                            ทีมที่ได้อันดับ 2
                        </div>
                    </div>
                    <div className="rewardmessage__image-1">
                        <img src={Imglist.reward_row_5_1} alt=''/>
                        <img src={Imglist.reward_row_5_2} alt=''/>
                    </div>
                    <div className="rewardmessage__text-title-small">
                        <img src={Imglist.medal_3} className="rewardmessage__icon rewardmessage__icon--1" alt=''/>
                        <div>
                            ทีมที่ได้อันดับ 3
                        </div>
                    </div>
                    <div className="rewardmessage__image-1">
                        <img src={Imglist.reward_row_6_1} alt=''/>
                        <img src={Imglist.reward_row_6_2} alt=''/>
                    </div>
                    <div className="rewardmessage__text-title-small">
                        <img src={Imglist.giftbox} className="rewardmessage__icon rewardmessage__icon--2"/>
                        <div>
                            ทีมที่ได้อันดับ 4
                        </div>
                    </div>
                    <div className="rewardmessage__image-1">
                        <img src={Imglist.reward_row_7_1} alt=''/>
                        <img src={Imglist.reward_row_7_2} alt=''/>
                    </div>
                </div>
                <div className="rewardmessage__ok" onClick={()=>props.setValues({modal_open: ''})}>
					<img src={Imglist.btn_ok} alt=''/>
				</div>
			</RewardModalContent>
        </ModalCore>
    )
}

const mapStateToProps = state => ({
    ...state.Modal,
    ...state.Main,
});

const mapDispatchToProps = { setValues, actCloseModal };

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RewardsModal);

const RewardModalContent = styled.div`
    position: relative;
    z-index: 20;
    padding: 2%;
    pointer-events: visible;
    width: 90%;
    max-width: 700px;
    .rewardmessage{
        &__rulecontent{
            max-height: 50vh;
            overflow-y: scroll;
            width: 100%;
            margin: 0 auto;
            background: rgba(243,211,230,.8);
            border-bottom-right-radius: 25px;
            padding: 2%;
        }
        &__text-head{
            color: #f80052;
            font-size: 1.5em;
            text-align: center;
        }
        &__text-title-small{
            color: #000;
            font-size: 1.1em;
            text-align: center;
            >div{
                position: relative;
                display: inline-block;
                vertical-align: middle;
                text-align: center;
            }
        }
        &__icon{
            display: inline-block;
            vertical-align: middle;
            width: 7%;
            margin-right: 2%;
            &--1{
                width: 4%;
            }
            &--2{
                width: 5%;
            }
            &--3{
                margin-bottom: 2%;
            }
            // position: absolute;
            // top: 40%;
            // transform: translate(0,-50%);
            // &--1{
            //     left: -19%;
            // }
            // &--2{
            //     left: -10%;
            // }
            // &--3{
            //     left: -35%;
            // }
        }
        &__rule{
            padding-left: 6%;
            font-size: 1.1em;
            color: #000;
            >li{
                list-style-type: disc;
                &:last-child{
                    list-style-type: none;
                }
            }
        }
        &__reward{
            padding-left: 6%;
            font-size: 1.1em;
            color: #000;
            >li{
                list-style-type: decimal;
            }
        }
        &__head{
            text-align: center;
            font-size: 1.5em;
            color: #fff;
            background: rgba(255,0,76,1);
            background: -moz-linear-gradient(top, rgba(255,0,76,1) 0%, rgba(255,0,123,1) 53%, rgba(255,0,123,1) 100%);
            background: -webkit-gradient(left top, left bottom, color-stop(0%, rgba(255,0,76,1)), color-stop(53%, rgba(255,0,123,1)), color-stop(100%, rgba(255,0,123,1)));
            background: -webkit-linear-gradient(top, rgba(255,0,76,1) 0%, rgba(255,0,123,1) 53%, rgba(255,0,123,1) 100%);
            background: -o-linear-gradient(top, rgba(255,0,76,1) 0%, rgba(255,0,123,1) 53%, rgba(255,0,123,1) 100%);
            background: -ms-linear-gradient(top, rgba(255,0,76,1) 0%, rgba(255,0,123,1) 53%, rgba(255,0,123,1) 100%);
            background: linear-gradient(to bottom, rgba(255,0,76,1) 0%, rgba(255,0,123,1) 53%, rgba(255,0,123,1) 100%);
            filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ff004c', endColorstr='#ff007b', GradientType=0 );
            border-top-left-radius: 25px;
        }
        &__close{
            position: absolute;
            width: 6%;
            right: -3%;
            top: -3%;
            cursor: pointer;
            >img{
                display: block;
            }
            @media(max-width: 850px) {
                right: 0;
                top: -2%;
            }
        }
        &__ok{
            width: 26%;
            margin: 1% auto 0;
            cursor: pointer;
            &:hover{
                opacity: .8;
            }
            >img{
                display: block;
            }
        }
        &__image-1{
            width: 100%;
            text-align: center;
            margin: 1% auto;
            >img{
                width: 10%;
                display: inline-block;
                margin: 0 2%;
            }
        }
    }
`;
